import { render } from "./ManagementPageWithActions.vue?vue&type=template&id=737e6512&scoped=true&lang=pug"
import script from "./ManagementPageWithActions.vue?vue&type=script&lang=js"
export * from "./ManagementPageWithActions.vue?vue&type=script&lang=js"

import "./ManagementPageWithActions.vue?vue&type=style&index=0&id=737e6512&lang=scss"
import "./ManagementPageWithActions.vue?vue&type=style&index=1&id=737e6512&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-737e6512"]])

export default __exports__